export function createContextManager<T>(initialValue: T) {
  const stack: Readonly<T>[] = [initialValue];
  return function withContext<R>(
    fn: (value: Readonly<T>, setValue: (value: T) => void) => R,
  ): R {
    let localStackCount = 0;
    const setValue = (value: T) => {
      localStackCount += 1;
      stack.push(value);
    };
    try {
      return fn(stack[stack.length - 1], setValue);
    } finally {
      stack.splice(stack.length - localStackCount, stack.length);
    }
  };
}
